module.exports = __webpack_public_path__ + "img/mon_rotated.b8393c43.png";